import { Box, useMediaQuery } from '@mui/material'
import { memo } from 'react'

import { Question } from '@/types'

import QuestionDelete from './QuestionDelete'
import QuestionEdit from './QuestionEdit'

interface QuestionCardActionsProps {
  question: Question
}

export const QuestionCardActions = memo<QuestionCardActionsProps>(({ question }) => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('sm'))
  const isTablet = useMediaQuery(({ breakpoints }) => breakpoints.down('md'))

  return (
    <Box
      data-qa="question-card-actions"
      sx={{
        position: 'absolute',
        top: isMobile ? 8 : 16,
        left: isMobile ? 8 : isTablet ? 16 : 24,
        display: 'flex',
        gap: isMobile ? 0.5 : 1,
        zIndex: 2,
        ...(isMobile && {
          backgroundColor: ({ palette }) => palette.background.default,
          backdropFilter: 'blur(4px)',
          borderRadius: 2,
          p: 0.5,
          boxShadow: ({ shadows }) => shadows[2],
        }),
      }}>
      <QuestionEdit isMobile={isMobile} question={question} />
      <QuestionDelete isMobile={isMobile} question={question} />
    </Box>
  )
})

QuestionCardActions.displayName = 'QuestionCardActions'
